import { useState } from "react";
import { t } from "i18next";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import RouteUrls from "../../../../helpers/urls/RouteUrls";
import { appendFormData } from "../../../../helpers/functions/form-append";
import AddLayout from "../../../../components/AddLayout";
import AddUserForm from "../../components/addForm";
import { validateEmail } from "../../../../helpers/functions/functions";

function AddUser() {
  const [formData, setFormData] = useState({
    user: "",
    password: "",
    passwordConfirm: "",
    name: "",
    email: "",
    perms: "",
    type: 1,
    parent: JSON.parse(localStorage.getItem("user")).id
  });
  const {
    user,
    password,
    passwordConfirm,
    email
  } = formData;
  const [errors, setErrors] = useState({});
  const [postFormData, setPostFormData] = useState(null);

  const checkInputs = () => {
    let temp_errors = {};

    if (user === "") {
      temp_errors.user = t("message.required", { item: t("user.user_id") });
    }
    if (password === "") {
      temp_errors.password = t("message.required", { item: t("auth.password") });
    }
    if (passwordConfirm === "") {
      temp_errors.passwordConfirm = t("message.required", { item: t("auth.password_confirm") });
    }
    if (passwordConfirm !== password) {
      temp_errors.passwordConfirm = t("message.password_confirm");
    }
    if (email === "") {
      temp_errors.email = t("message.required", { item: t("user.email") });
    } else if (!validateEmail(email)) {
      temp_errors.email = t("message.format", { item: t("user.email") });
    }

    setErrors(temp_errors);

    if (Object.keys(temp_errors).length === 0) {
      createPostFormData();
    }
  }

  const createPostFormData = () => {
    setPostFormData(appendFormData(formData));
  }

  return (
    <AddLayout
      title={t("user.user")}
      addUrl={ApiUrls.user.add}
      listUrl={RouteUrls.user.list}
      onClick={checkInputs}
      postFormData={postFormData}
    >
      <AddUserForm
        formData={formData}
        setFormData={setFormData}
        errors={errors}
        setErrors={setErrors}
      />
    </AddLayout>
  );
}

export default AddUser;
